import {
    Badge,
    Box,
    Flex,
    Tabs,
    Text,
    Input,
    InputGroup,
    Button,
    Select,
    Portal,
    createListCollection,
} from "@chakra-ui/react";

import {
    Search,
    SlidersHorizontal,
} from "lucide-react";

const DataTableHeader = ({
    title,
    total = 0,
    filters = [],
    activeFilter,
    onFilterChange,
    rightAction,
    onFilterClick,
    search,
    onSearchChange,
}) => {
    const filterCollection =
        createListCollection({
            items: filters.map(
                filter => ({
                    label: filter,
                    value: filter,
                })
            ),
        });

    return (
        <Flex
            direction={{
                base: "column",
                lg: "row",
            }}
            justify="space-between"
            align={{
                base: "stretch",
                lg: "center",
            }}
            p={{
                base: 4,
                md: 6,
            }}
            gap={4}
        >
            {/* Title */}
            <Flex
                align="center"
                gap={3}
                flexWrap="wrap"
            >
                <Text
                    fontSize="2xl"
                    fontWeight="700"
                    color="#071D54"
                >
                    {title}
                </Text>

                <Badge
                    colorPalette="blue"
                    variant="subtle"
                    px={3}
                    py={1}
                    borderRadius="full"
                >
                    {total} TOTAL
                </Badge>
            </Flex>

            {/* Controls */}
            <Flex
                direction={{
                    base: "column",
                    lg: "row",
                }}
                gap={3}
                align={{
                    base: "stretch",
                    lg: "center",
                }}
                w={{
                    base: "100%",
                    lg: "auto",
                }}
            >
                {filters.length > 0 && (
                    <>
                        {/* Mobile Dropdown */}
                        <Box
                            display={{
                                base: "block",
                                lg: "none",
                            }}
                            w="100%"
                        >
                            <Select.Root
                                collection={
                                    filterCollection
                                }
                                value={[
                                    activeFilter,
                                ]}
                                onValueChange={(
                                    details
                                ) =>
                                    onFilterChange?.(
                                        details
                                            .value[0]
                                    )
                                }
                            >
                                <Select.Trigger
                                    borderRadius="5px"
                                    h="42px"
                                >
                                    <Select.ValueText placeholder="Select Status" />
                                </Select.Trigger>

                                <Portal>
                                    <Select.Positioner>
                                        <Select.Content>
                                            {filterCollection.items.map(
                                                item => (
                                                    <Select.Item
                                                        key={
                                                            item.value
                                                        }
                                                        item={
                                                            item
                                                        }
                                                    >
                                                        {
                                                            item.label
                                                        }

                                                        <Select.ItemIndicator />
                                                    </Select.Item>
                                                )
                                            )}
                                        </Select.Content>
                                    </Select.Positioner>
                                </Portal>
                            </Select.Root>
                        </Box>

                        {/* Desktop Tabs */}
                        <Box
                            display={{
                                base: "none",
                                lg: "block",
                            }}
                        >
                            <Tabs.Root
                                value={
                                    activeFilter
                                }
                                onValueChange={e =>
                                    onFilterChange?.(
                                        e.value
                                    )
                                }
                            >
                                <Tabs.List>
                                    {filters.map(
                                        filter => (
                                            <Tabs.Trigger
                                                key={
                                                    filter
                                                }
                                                value={
                                                    filter
                                                }
                                            >
                                                {
                                                    filter
                                                }
                                            </Tabs.Trigger>
                                        )
                                    )}
                                </Tabs.List>
                            </Tabs.Root>
                        </Box>
                    </>
                )}

                {/* Search */}
                <InputGroup
                    w={{
                        base: "100%",
                        md: "260px",
                    }}
                    startElement={
                        <Search size={16} />
                    }
                >
                    <Input
                        placeholder="Search..."
                        value={search}
                        onChange={e =>
                            onSearchChange?.(
                                e.target.value
                            )
                        }
                    />
                </InputGroup>

                {/* Filter Button */}
                {onFilterClick && (
                    <Button
                        variant="outline"
                        onClick={
                            onFilterClick
                        }
                    >
                        <SlidersHorizontal
                            size={18}
                        />
                    </Button>
                )}

                {/* Additional Action */}
                {rightAction}
            </Flex>
        </Flex>
    );
};

export default DataTableHeader;